<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let users = [];
  let loading = true;
  let error = null;

  let currentPage = 1;
  let pageSize = 10;
  let totalUsers = 0;
  let searchQuery = "";

  let showEditModal = false;
  let currentUser = null;
  let editUserData = { spins: 0, stars_balance: 0, daily_streak: 0 };

  let showAwardModal = false;
  let awardData = { user_id: null, spins: 0, stars: 0, reason: '' };

  onMount(() => {
    loadUsers();
  });

  async function loadUsers() {
    loading = true;
    error = null;
    const params = { page: currentPage, pageSize: pageSize, search: searchQuery || undefined };
    const result = await fetchAdminAPI('/users', 'GET', params, authData);
    if (result.success) {
        users = result.data.data || [];      // <--- ИЗМЕНЕНИЕ
        totalUsers = result.data.total || 0; // <--- ИЗМЕНЕНИЕ
    } else {
      error = result.message;
      users = [];
      totalUsers = 0;
    }
    loading = false;
  }

  function handleSearch() {
    currentPage = 1;
    loadUsers();
  }

  function openEditModal(user) {
    currentUser = user;
    editUserData = {
      spins: user.Spins,
      stars_balance: user.StarsBalance,
      daily_streak: user.DailyStreak,
    };
    showEditModal = true;
  }

  async function handleUpdateUser() {
    if (!currentUser) return;
    const payload = {
      spins: Number(editUserData.spins),
      stars_balance: Number(editUserData.stars_balance),
      daily_streak: Number(editUserData.daily_streak),
    };
    if (payload.spins < 0 || payload.stars_balance < 0 || payload.daily_streak < 0) {
        alert("Значения не могут быть отрицательными.");
        return;
    }

    const result = await fetchAdminAPI(`/users/${currentUser.TelegramID}`, 'PATCH', payload, authData);
    if (result.success) {
      showEditModal = false;
      currentUser = null;
      loadUsers();
    } else {
      alert(`Ошибка обновления пользователя: ${result.message}`);
    }
  }

  function openAwardModal(user) {
    awardData = { user_id: user.TelegramID, spins: 0, stars: 0, reason: '' };
    showAwardModal = true;
  }

  async function handleAwardUser() {
    if (!awardData.user_id) return;
    if (awardData.spins === 0 && awardData.stars === 0) {
        alert("Укажите количество спинов или звезд.");
        return;
    }
    const payload = {
      user_id: awardData.user_id,
      spins: Number(awardData.spins),
      stars: Number(awardData.stars),
      reason: awardData.reason,
    };
    const result = await fetchAdminAPI('/users/award', 'POST', payload, authData);
    if (result.success) {
      showAwardModal = false;
      loadUsers(); // Обновить список, т.к. балансы могли измениться
    } else {
      alert(`Ошибка начисления/списания: ${result.message}`);
    }
  }


  function changePage(newPage) {
    currentPage = newPage;
    loadUsers();
  }

  $: totalPages = Math.ceil(totalUsers / pageSize);
</script>

<div class="users-admin-section">
  <div class="admin-section-header">
    <h2>Управление пользователями</h2>
    <!-- Нет кнопки "Создать" пользователя, т.к. они регистрируются сами -->
  </div>
  
  <div class="filters-bar">
    <input type="text" bind:value={searchQuery} placeholder="Поиск по Telegram ID или Username" on:input={handleSearch} on:keypress={(e) => e.key === 'Enter' && handleSearch()}>
    <button class="admin-primary" on:click={handleSearch}>
       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px; vertical-align: text-bottom;">
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
      </svg>
      Найти
    </button>
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка пользователей...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if users.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">{searchQuery ? 'Пользователи по вашему запросу не найдены.' : 'Пользователей пока нет.'}</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table">
          <thead>
            <tr>
              <th>TG ID</th>
              <th>Username</th>
              <th>Спины</th>
              <th>Звезды</th>
              <th>Стрик</th>
              <th>Реферер ID</th>
              <th>Дата рег.</th>
              <th style="text-align: right;">Действия</th>
            </tr>
          </thead>
          <tbody>
            {#each users as user (user.TelegramID)}
              <tr>
                <td>{user.TelegramID}</td>
                <td>{user.Username || '–'}</td>
                <td>{user.Spins}</td>
                <td>{user.StarsBalance}</td>
                <td>{user.DailyStreak}</td>
                <td>{user.ReferrerID || '–'}</td>
                <td>{new Date(user.CreatedAt).toLocaleDateString()}</td>
                <td class="admin-actions" style="text-align: right;">
                  <button class="admin-action-button admin-edit" on:click={() => openEditModal(user)}>Баланс</button>
                  <button class="admin-action-button admin-award" on:click={() => openAwardModal(user)}>Начислить</button>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
      {#if totalUsers > 0}
      <div class="pagination">
        <span class="page-info">Показано {users.length} из {totalUsers} пользователей</span>
        <div class="page-controls">
          <button class="admin-action-button" on:click={() => changePage(currentPage - 1)} disabled={currentPage <= 1}>Назад</button>
          <span>Стр. {currentPage} из {totalPages}</span>
          <button class="admin-action-button" on:click={() => changePage(currentPage + 1)} disabled={currentPage >= totalPages}>Вперед</button>
          <select bind:value={pageSize} on:change={() => { currentPage = 1; loadUsers(); }} aria-label="Записей на странице">
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>
      {/if}
    {/if}
  </div>
</div>

<!-- Edit User Balance Modal -->
{#if showEditModal && currentUser}
  <div class="modal" on:click|self={() => showEditModal = false} role="dialog" aria-modal="true">
    <div class="modal-content">
      <h3>Редактировать баланс: {currentUser.Username || currentUser.TelegramID}</h3>
      <form on:submit|preventDefault={handleUpdateUser} class="admin-form">
        <label for="edit-spins">Спины:</label>
        <input id="edit-spins" type="number" bind:value={editUserData.spins} min="0" required>
        
        <label for="edit-stars">Баланс звезд:</label>
        <input id="edit-stars" type="number" bind:value={editUserData.stars_balance} min="0" required>
        
        <label for="edit-streak">Дневной стрик (0-13):</label>
        <input id="edit-streak" type="number" bind:value={editUserData.daily_streak} min="0" max="13" required>
        
        <div class="form-actions">
          <button type="button" on:click={() => {showEditModal = false; currentUser = null;}} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">Сохранить</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<!-- Award User Modal -->
{#if showAwardModal}
  <div class="modal" on:click|self={() => showAwardModal = false} role="dialog" aria-modal="true">
    <div class="modal-content">
      <h3>Начислить/Списать средства</h3>
      <p style="margin-bottom: 15px; font-size: 0.95em;">Пользователь ID: <strong>{awardData.user_id}</strong></p>
      <form on:submit|preventDefault={handleAwardUser} class="admin-form">
        <label for="award-spins">Спины (отрицательное для списания):</label>
        <input id="award-spins" type="number" bind:value={awardData.spins} required>
        
        <label for="award-stars">Звезды (отрицательное для списания):</label>
        <input id="award-stars" type="number" bind:value={awardData.stars} required>
        
        <label for="award-reason">Причина (обязательно):</label>
        <input id="award-reason" type="text" bind:value={awardData.reason} required>
        
        <div class="form-actions">
          <button type="button" on:click={() => {showAwardModal = false;}} class="admin-secondary">Отмена</button>
          <button type="submit" class="admin-primary">Выполнить</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  .table-responsive-wrapper { overflow-x: auto; }

</style>